<template>
  <div class="switcher" @click="toggleLang">
    <img :src="currentFlag" width="20" height="20" alt="flag" />
    <span class="label">{{ currentLabel }}</span>
  </div>
</template>

<script setup>
import { useI18n } from 'vue-i18n'
import { computed } from 'vue'
import ruFlag from '@/assets/ru-flag.svg'
import kgFlag from '@/assets/kg-flag.svg'

const { locale } = useI18n()

const toggleLang = () => {
  const newLang = locale.value === 'kg' ? 'ru' : 'kg'
  locale.value = newLang
  localStorage.setItem('i18nextLng', newLang)
}

const currentFlag = computed(() => locale.value === 'kg' ? ruFlag : kgFlag)
const currentLabel = computed(() => locale.value === 'kg' ? 'RU' : 'KG')
</script>

<style scoped>
.switcher {
  display: flex;
  align-items: center;
  gap: 6px;
  max-width: 63px;
  padding: 4px 8px;
  border: 1px solid #ccc;
  border-radius: 6px;
  background: #fff;
  cursor: pointer;
  transition: background 0.2s ease;
}

.switcher:hover {
  background: #f5f5f5;
}

.label {
  font-size: 14px;
  font-weight: 500;
  color: #333;
}
</style>
